import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../utils/utils";

export const sliderImageColumns = ({handleEdit, handleDelete, PAGE_SIZE, API_URL}) => [
   {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Image",
    render: (row) => 
        <span>
          <img src={getImageUrl(row.image)} alt="Slider Image" style={{width: "100px", height: "100px"}} />
        </span>,    
  },
  {
    label: "Status",
    render: (row) => (
      <div className="checkbox-wrapper-8">
        <input
          className="tgl tgl-skewed"
          type="checkbox"
          checked={row.status === "Active"}
          readOnly
        />
        <label
          className="tgl-btn"
          data-tg-off="Inactive"
          data-tg-on="Active"
        />
      </div>
    ),
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link  onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        <li>
          <Link  onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
];
